import * as React from 'react'
import { authService } from '../../../services'
import { ConfirmRegisterPage } from '../components/ConfirmRegisterPage'

type ConfirmRegisterProps = {
  match: {
    params: {
      code: string
    }
  }
}

type ConfirmRegisterState = {
  user?: IUser,
  error: boolean,
  errorMessage?: string,
}

export default class ConfirmRegister extends React.Component<ConfirmRegisterProps, ConfirmRegisterState> {
  state: ConfirmRegisterState = {
    error: false
  }

  componentDidMount() {
    const code = this.props.match.params.code
    authService.confirmRegister(code)
      .then(user => {
        this.setState({
          user: user
        })
      })
      .catch(error => {
        this.setState({
          error: true,
          errorMessage: error.message
        })
      })
  }

  render() {
    let {user, error, errorMessage} = this.state
    return (
      <ConfirmRegisterPage user={user} error={error} message={errorMessage}/>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Auth/containers/ConfirmRegister.tsx